export enum StatusRabbitMQMessage {
    Created = 0,
    Started = 1,
    Finished = 2,
    Error = 3,
    GenerateFiles = 4
}